import { FC } from 'react';

import { Link } from 'react-router-dom';
import giftPromStoreMain from 'src/assets/gift/gift-prom-store-main.png';
import { DeathCharacter } from '@shared/miscValues';

import { GiftCallHelperBox } from './GiftCallHelperBox';

type GiftStoreGateVariant =
  | 'closed' // 발인 후 30일 경과로 온라인 주문 마감
  | 'no-bugo' // 부고 링크(bugoId) 없이 접근
  | 'invalid'; // bugoId는 있으나 해당 부고가 없음(만료/오타 등)

interface GiftStoreGateNoticeProps {
  variant: GiftStoreGateVariant;
  deceasedName?: string | null;
  bugoId?: string | null;
}

const CALL_TAIL = '아래 번호로 전화 주시면 도와드리겠습니다.';

export const GiftStoreGateNotice: FC<GiftStoreGateNoticeProps> =
  function GiftStoreGateNotice({ variant, bugoId }) {
    const title =
      variant === 'closed'
        ? '온라인 주문이 마감되었습니다'
        : variant === 'no-bugo'
        ? '부고 링크로 접속해 주세요'
        : '유효하지 않은 링크예요';

    const body =
      variant === 'closed'
        ? `온라인 주문 기간이 종료되었습니다.\n추가로 답례품이 필요하시면\n${CALL_TAIL}`
        : variant === 'no-bugo'
        ? `답례품 스토어는 문자로 받으신\n부고 알림 링크를 통해 이용하실 수 있습니다.\n링크를 찾기 어려우시면\n${CALL_TAIL}`
        : `부고 정보를 찾을 수 없습니다.\n링크가 만료되었거나 주소가 정확하지 않을 수 있어요.\n${CALL_TAIL}`;

    return (
      <div className="min-h-screen bg-gray-50">
        {/* 히어로 배너 (카탈로그와 동일하게 유지해 톤을 맞춘다) */}
        <div>
          <img src={giftPromStoreMain} alt="답례품 안내" className="w-full" />
        </div>

        <div className="px-6 py-10">
          <div className="center-box flex-col gap-3 rounded-2xl bg-white px-6 py-8 text-center shadow-sm ring-1 ring-gray-100">
            <p className="text-lg font-bold text-gray-900">{title}</p>
            <p className="whitespace-pre-line break-keep text-sm leading-relaxed text-gray-500">
              {body}
            </p>
            {/* 마감돼도 이미 진행한 주문 내역은 계속 확인할 수 있게 한다. */}
            {variant === 'closed' && bugoId && (
              <Link
                to={`/gift-store/orders?bugoId=${bugoId}`}
                className="mt-2 inline-block rounded-full bg-gray-900 px-6 py-2.5 text-sm font-semibold text-white"
              >
                주문내역 보기
              </Link>
            )}
          </div>
        </div>

        <GiftCallHelperBox />
      </div>
    );
  };
